// extracted by mini-css-extract-plugin
export default {"dangerButton":"DangerButton_dangerButton__iT2TN"};